export interface TabSuffixMapping {
  suffix: string;
  id: string;
}

export interface TabIncludesMapping {
  substring: string;
  id: string;
}

/**
 * Creates a mapper function that returns a tab ID when the currentPath ends with any configured suffix.
 * The first matching suffix wins. If none match, returns defaultId.
 */
export function createEndsWithTabIdMapper(
  mappings: readonly TabSuffixMapping[],
  defaultId: string
) {
  return (currentPath: string): string => {
    for (const mapping of mappings) {
      if (currentPath.endsWith(mapping.suffix)) {
        return mapping.id;
      }
    }
    return defaultId;
  };
}

/**
 * Creates a mapper function that returns a tab ID when the currentPath includes any configured substring.
 * The first matching substring wins. If none match, returns defaultId.
 */
export function createIncludesTabIdMapper(
  mappings: readonly TabIncludesMapping[],
  defaultId: string
) {
  return (currentPath: string): string => {
    for (const mapping of mappings) {
      if (currentPath.includes(mapping.substring)) {
        return mapping.id;
      }
    }
    return defaultId;
  };
}
